<template>
	<div class="lang-control">
		<a href="/" v-if="store.lang == 'es'" @click.prevent="setLang('en')">
			<img src="/themes/rise-theme/dist/images/estate/CC_english.png" />
		</a>
		<br />
		<a href="/" v-if="store.lang == 'en'" @click.prevent="setLang('es')">
			<img src="/themes/rise-theme/dist/images/estate/CC_spanish.png" />
		</a>
	</div>
</template>

<script>
import { store } from '../spa/store';

export default {
	data() {
		return {
			store
		}
	},
	methods: {
		setLang(l) {
			store.lang = l;
			window.localStorage.setItem('user_lang', l);
		},
	},
}
</script>

<style lang="scss">
.lang-control {
	position: fixed;
	bottom: 130px;
	right: 100px;
	z-index: 6;

	@media(max-width: 1600px) {
		right: 40px;
	}

	@media(max-width: 1280px) {
		right: 22px;
	}

	@media(max-width: 600px) {
		right: 4%;
		bottom: 165px;
	}

	img {
		@media(min-width: 1600px) {
			width: 70px;
			height: 70px;
		}

		@media(max-width: 1600px) {
			width: 58px;
			height: 58px;
		}

		@media(max-width: 1280px) {
			width: 50px;
			height: 50px;
		}

		@media(max-width: 600px) {
			width: 50px;
			height: 50px;
		}
		@media screen and (max-width: 991px) and (orientation: landscape) {
			width: 36px;
			height: 36px;
		}
	}

	@media screen and (max-width: 991px) and (orientation: landscape) {
		right: 60px;
		bottom: 22px;
	}
}
</style>
